<template>
  <div>
    <CompareFeaturesHero
      @upgradeSub="redirectToPayment"
      :currency="currency"
      :price="price"
      :isLoading="isPriceLoading"
      :isAdmin="hasAdminOrSupport"
    />
    <ContainerLayout class="tw:flex-col tw:my-12">
      <StudioPlusProductsHighlight />
      <div class="tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:px-4 tw:mx-auto tw:my-12">
        <h3 class="tw:text-2xl tw:font-bold tw:text-center tw:mb-12">
          {{ $t('plus_product_page_feature_comparison') }}
        </h3>
        <CompareFeaturesCards
          @upgradeSub="redirectToPayment"
          :currency="currency"
          :price="price"
          :isLoading="isPriceLoading"
          :isAdmin="hasAdminOrSupport"
        />
      </div>
    </ContainerLayout>
    <StudioPlusBanner @upgradeSub="redirectToPayment" :isAdmin="hasAdminOrSupport" />
    <ContainerLayout class="tw:flex-col">
      <StudioPlusFaqSection />
    </ContainerLayout>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStudioPlusPrice } from '@/components/payment/queries'
import { selectedAccommodationId, useAccommodationsByOrgId, useUserDetails } from '@/layouts/queries'
import { useSessionValues } from '@/composables/useSessionValues'

import appAnalytics from '@/utils/tracking'

import ContainerLayout from '@/layouts/ContainerLayout.vue'
import CompareFeaturesCards from '@/components/studioPlus/CompareFeaturesCards.vue'
import CompareFeaturesHero from '@/components/studioPlus/CompareFeaturesHero.vue'
import StudioPlusProductsHighlight from '@/components/studioPlus/StudioPlusProductsHighlight.vue'
import StudioPlusBanner from '@/components/studioPlus/StudioPlusBanner.vue'
import StudioPlusFaqSection from '@/components/studioPlus/StudioPlusFaqSection.vue'

const route = useRoute()
const router = useRouter()

const { currency, hasAdminOrSupport, language, userId, selectedOrganisationId } = useSessionValues()
const { studioPlusPrice, isLoading, isFetching } = useStudioPlusPrice({ selectedAccommodationId, currency })
const isPriceLoading = computed(() => isLoading.value || isFetching.value)
const price = computed(() => studioPlusPrice.value?.baseSubscriptionMonthlyPrice ?? 0)

const { userDetails } = useUserDetails(userId)
const { currentAccommodation } = useAccommodationsByOrgId(selectedOrganisationId)

const redirectToPayment = () => {
  router.push({ name: 'studio-plus-payment' })
  appAnalytics.track(appAnalytics.events.SP_COMPARE_FEATURES_CARD_CLICKED, {
    item_id: selectedAccommodationId.value,
    itemName: currentAccommodation?.value?.name,
    price: price.value,
    language: language.value,
    studioUserId: userDetails?.value?.id,
    email: userDetails?.value?.email,
    firstName: userDetails?.value?.firstName,
    lastName: userDetails?.value?.lastName,
  })
}

onMounted(() => {
  const trafficSource = window.sessionStorage?.getItem?.('traffic_source')
  appAnalytics.track(appAnalytics.events.SP_COMPARE_FEATURES_VISITED, {
    item_id: selectedAccommodationId.value,
    price: price.value,
    source: route.query ? route.query : '',
    traffic_source: trafficSource ?? '',
  })
})
</script>
